const ParcelVisitorsCards = ({ activeTab, rows = [] }) => {
    const isParcels = activeTab === 'parcels';
    const formattedRows = rows || [];

    return (
        <div className="card-table-container flex flex-col gap-[15px] md:hidden mt-[15px]">
            {formattedRows.length === 0 ? (
                <p className="info-text text-center">No data found</p>
            ) : (
                formattedRows.map((row, idx) => (
                    <div
                        key={row._id || idx}
                        className="border border-gray-300 rounded-lg p-6 w-full"
                    >
                        {isParcels ? (
                            <>
                                <div className="detail-row -mt-[10px]">
                                    <div className="detail-column">
                                        <p className="detail-label">Carrier</p>
                                        <p className="detail">{row.carrier}</p>
                                    </div>
                                    <div className="detail-column]">
                                        <p className="detail-label">Tracking Number</p>
                                        <p className="detail">{row.trackingNumber}</p>
                                    </div>
                                </div>
                                <div className="detail-column">
                                    <p className="detail-label">Description</p>
                                    <p className="detail">{row.description}</p>
                                </div>
                                <div className="detail-row -mt-[10px]">
                                    <div className="detail-column mb-[-20px]">
                                        <p className="detail-label">Status</p>
                                        <span className={`text-white text-sm w-[100px] inline-block text-center py-1 rounded-full
                                                ${row.status === 'Pending' ? 'bg-blue-900' :
                                                row.status === 'Delivered' ? 'bg-green-500' :
                                                    row.status === 'Picked Up' ? 'bg-yellow-500' :
                                                        row.status === 'Lost' ? 'bg-red-600' :
                                                            row.status === 'Returned' ? 'bg-gray-500' :
                                                                'bg-gray-400'
                                            }
                                                `}>
                                            {row.status}
                                        </span>
                                    </div>
                                    <div className="detail-column mb-[-20px]">
                                        <p className="detail-label">Delivery Date</p>
                                        <p className="detail">
                                            {row.deliveryDate ? new Date(row.deliveryDate).toLocaleDateString() : '—'}
                                        </p>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="detail-column">
                                    <p className="detail-label">Name</p>
                                    <p className="detail">{row.givenName} {row.lastName}</p>
                                </div>
                                <div className="detail-column -mt-[10px]">
                                    <p className="detail-label">Purpose</p>
                                    <p className="detail">{row.purpose}</p>
                                </div>
                                <div className="detail-row -mt-[10px]">
                                    <div className="detail-column mb-[-20px]">
                                        <p className="detail-label">Check-In</p>
                                        <p className="detail">
                                            {row.checkIn ? new Date(row.checkIn).toLocaleDateString() : '—'}
                                        </p>
                                    </div>
                                    <div className="detail-column mb-[-20px]">
                                        <p className="detail-label">Check-Out</p>
                                        <p className="detail">
                                            {row.checkOut ? new Date(row.checkOut).toLocaleDateString() : '—'}
                                        </p>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default ParcelVisitorsCards;
